import { useQuery } from '@tanstack/react-query';
import { simulationV2 } from '~/services/simulation-service';
import { useQueryCreator } from '~/hooks/useQueryCreator';
import type { SimulationRawResultsV2ListParams } from '~/store/simulation/types';

export function useSimulationRawResultsList(
  params: SimulationRawResultsV2ListParams,
  refetchInterval?: number | false,
) {
  const query = useQuery({
    ...useQueryCreator(simulationV2.rawResultsList, { args: [params] }),
    refetchInterval,
  });
  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
  };
}

export function useSimulationRawResultDetail(simulationId: string, historicalShipmentId: string | undefined) {
  const query = useQuery({
    ...useQueryCreator(simulationV2.rawResultDetail, { args: [simulationId, historicalShipmentId ?? ''] }),
    enabled: !!historicalShipmentId,
  });
  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
  };
}

export function useSimulationRawResultsFilterOptions(simulationId: string, enabled = true) {
  const query = useQuery({
    ...useQueryCreator(simulationV2.rawResultsFilterOptions, { args: [simulationId] }),
    enabled,
  });
  return { data: query.data, isLoading: query.isLoading };
}
